const questions = [
    { 
        question:  'On Monday, 50 children bought a ticket for the ghost train attraction. If 30% more children bought a ticket to this attraction on the following Tuesday, how many tickets were sold during those two days?  ',
 question: "Choose the word of words that, when inserted in the sentence to replace the blank or blanks, fits the best with the meaning of the sentence. On the occasion of its 30th anniversary, a large ___ of sandwich-pastry stores in Belgium has been ranked as the most ___ sandwiches in the Kingdom.",
        options: ["frame ... best", "succession ... bad", "chain ... popular", "closing ... nice", " line ... spicy" ],
        answer:  "chain ... popular",
    }, 

    {      
      question:"Pick a prime number" ,
       options: [2, 80, 115, 85 ], 
        answer: 115 
    } , 

    {
        question: 'Four individuals of different sizes - Elisabeth, Kiera, Guy and Amos - behave according to the following rule: each one trusts exclusively an individual of a higher size than him or herself. We know that Elisabeth only trusts Kiera.One of the following situations is not possible. Which one? ',
        options: [
            "Amos trusts Kiera" ,
        ' Guy does not trust Amos',
        ' Amos only trusts Elisabeth ', 
        ' Guy trusts everyone else',
        ' Guy trusts Kiera'
     ],
     answer: ' Amos only trusts Elisabeth '
    },
    {
       
        question: "What is the capital of France?",
        options: ["Paris", "London", "Madrid", "Rome"],
        answer: "Paris"
      },
      {
        question: "What is the largest planet in the solar system?",
        options: ["Earth", "Jupiter", "Saturn", "Mars"],
        answer: "Jupiter"
      },
      {
        question: "Who was the first president of the United States?",
        options: ["George Washington", "John Adams", "Thomas Jefferson", "James Madison"],
        answer: "George Washington"
      } , 
      {
        question: "Which country won the 2022 world cup?", 
        options:["France", "Argentina", "Morroco", "Corotia"], 
        answer: "Argentina"
      },
      {
        question: "Who is the Goat  🐐🐐 of Football?", 
        options: ["Messi", "Ronaldo", "Mppabe", "Rashford"],
        answer: "Messi"
      } ,
      {
      question:  "Rearrange the phrase below to form a meaningful sentence “CHIEDITOREF” ",
      options: ["Chief Editor","Editor- in- Chief","Editors-in-chief"," All of the above"], 
      answer: "Chief Editor", 
      },
      {
        question: "Is HTML a proggraming language?", 
        options: ["Dey play ", "Yes" , "No" , "What is HTML abeg?"],
        answer: "No",

      },
      {
      question: "  8:4 as 10:.....",
      options: [24,5, 8,50], 
      answer: 5
      },
      {
        question: "It takes Max three hours to run 30 kilometers. Georges, on the other hand, travels the same distance in 2 hours and 20 minutes. If both are to complete a 15-kilometre race, how long before Max will Georges arrive to the finish line?",
        options: [
            "10 minutes",
            "20 minutes",
            "50 minutes",
            "40 minutes"

        ],
        answer: "20 minutes"
      },
          {
        question: "Who is wining 2023 Nigeria Presidential Election?", 
        options: ["Peter Obi", "Bala bala blue", "Kwenkwaso","Sug president"],
        answer: 'Peter Obi'
    }

    
];

export default questions;